module.exports = __webpack_public_path__ + "img/ic_coin.e5675a6a.png";